"use strict";
// THIS CODE WAS AUTOMATICALLY GENERATED
// DO NOT EDIT THIS CODE BY HAND
// RUN THE FOLLOWING COMMAND FROM THE WORKSPACE ROOT TO REGENERATE:
// npx nx generate-lib repo
Object.defineProperty(exports, "__esModule", { value: true });
exports.es2017_object = void 0;
const base_config_1 = require("./base-config");
exports.es2017_object = {
    ObjectConstructor: base_config_1.TYPE,
};
//# sourceMappingURL=es2017.object.js.map